module.exports = __webpack_public_path__ + "static/feature-d387022b4d06a2fbe16163805fa90f4a.png";